import { useContext } from "react";
import ToggleSidebarContext from "./ToggleSidebarContext";

export default function ExpandSidebar() {
  const { setCollapseSidebar } = useContext(ToggleSidebarContext);
  return (
    <div className="h-full  flex items-center justify-center bg-slate-200 p-1">
      <svg
        className="size-6 cursor-pointer"
        onClick={() => setCollapseSidebar(false)}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="8" fill="white" />
        <g clip-path="url(#clip0_1470_4620)">
          <path
            d="M10.4117 7.78875C10.528 7.905 10.528 8.09625 10.4117 8.2125L6.81172 11.8125C6.69547 11.9287 6.50422 11.9287 6.38797 11.8125C6.27172 11.6962 6.27172 11.505 6.38797 11.3888L9.77609 8.00062L6.38797 4.6125C6.27172 4.49625 6.27172 4.305 6.38797 4.18875C6.50422 4.0725 6.69547 4.0725 6.81172 4.18875L10.4117 7.78875Z"
            fill="#94A3B8"
          />
        </g>
        <defs>
          <clipPath id="clip0_1470_4620">
            <rect
              width="6"
              height="9.6"
              fill="white"
              transform="translate(4.80078 3.19922)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
